import { Color } from "../types/common"

export enum RunState {
    RunProcessing = 0,
    RunPending,
    RunProcessed,
    RunCompleted,
    RunFailed,
    RunSwitchedOff,
    RunHalted,
    RunFiltered,
}

export const RunStateToName = {
    0: "Processing",
    1: "Pending",
    2: "Processed",
    3: "Completed",
    4: "Failed",
    5: "Switched Off",
    6: "Halted",
    7: "Filtered",
}

export const RunStateToColor: Record<RunState, Color> = {
    0: "grey",
    1: "yellow",
    2: "green",
    3: "green",
    4: "red",
    5: "grey",
    6: "grey",
    7: "grey",
}

export enum RunInstanceState {
    RunInstanceProcessing = 0,
    RunInstancePending,
    RunInstanceProcessed,
    RunInstanceCompleted,
    RunInstanceFailed,
    RunInstanceSwitchedOff,
    RunInstanceHalted,
    RunInstanceFiltered,
}

export const RunInstanceStateToName = {
    0: "Processing",
    1: "Pending",
    2: "Processed",
    3: "Completed",
    4: "Failed",
    5: "Switched Off",
    6: "Halted",
    7: "Filtered",
}

export const RunInstanceStateToColor: Record<RunInstanceState, Color> = {
    0: "grey",
    1: "yellow",
    2: "green",
    3: "green",
    4: "red",
    5: "grey",
    6: "grey",
    7: "grey",
}

export const RunInstanceNameToColor: Record<string, Color> = {
    "Processing": "grey",
    "Pending": "yellow",
    "Processed": "green",
    "Completed": "green",
    "Failed": "red",
    "Switched Off": "grey",
    "Halted": "grey",
    "Filtered": "grey",
}

export enum NodeRunInstanceState {
    NodeRunInstanceProcessing = 0,
    NodeRunInstancePending,
    NodeRunInstanceProcessed,
    NodeRunInstanceCompleted,
    NodeRunInstanceFailed,
    NodeRunInstanceSwitchedOff,
    NodeRunInstanceHalted,
    NodeRunInstanceFiltered,
}

export const NodeRunInstanceStateToName = {
    0: "Processing",
    1: "Pending",
    2: "Processed",
    3: "Completed",
    4: "Failed",
    5: "Switched Off",
    6: "Halted",
    7: "Filtered",
}

export const NodeRunInstanceStateToColor: Record<NodeRunInstanceState, Color> = {
    0: "grey",
    1: "yellow",
    2: "green",
    3: "green",
    4: "red",
    5: "grey",
    6: "grey",
    7: "grey",
}

export enum NodeTriggerState {
	NodeTriggerProcessing = 0,
	NodeTriggerPending,
	NodeTriggerProcessed,
	NodeTriggerCompleted,
	NodeTriggerFailed,
	NodeTriggerSwitchedOff,
}

export enum InternalNodeType {
    InternalNodeTypeAction = 0,
    InternalNodeTypeTrigger,
    InternalNodeTypePolling,
}

export enum NodeState {
	NodeStatePullPending = 0,
	NodeStatePullProcessing,
	NodeStatePullCompleted,
	NodeStatePullFailed,
}

export enum NodeSaveState {
	NodeSaved = 0,
	NodeSavePostSavecalled,
	NodeSavePostSaveFailed,
	NodeSavePostSaveCompleted,
}